/* unplugin-vue-components disabled */import script from "./DeleteTimer.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteTimer.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteTimer.vue?vue&type=style&index=0&id=4ff72428&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff72428"]])

export default __exports__